import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/preview`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/preview`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/${jobId}/preview`;
